<template>
  <div class="verval">
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h1 class="headline info--text"> <strong>Daftar</strong> Laporan Ajuan Bantuan Pendampingan PA</h1>
            <div>
              Modul ini digunakan untuk melihat Daftar Laporan Ajuan Bantuan Pendampingan PA
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- <statistik :value="statistik"></statistik>-->
    <!--daftar-->
    <v-card flat>
      <v-card-title class="pa-0">
        <base-table-header @filter="onFilter" @search="onSearch" @reload="onReload" :btnFilter="true">
          <template v-slot:subtitle>
            <div class="body-1 black--text">
              Jumlah Data <span class="blue--text font-weight-medium">{{ total }}</span>
            </div>
          </template>
          <template v-slot:toolbar>
            <div style="max-width: 350px">
              <v-row no-gutters>
                <v-col cols="12" lg="6" class="py-2 pr-1">
                  <v-select
                    v-model="gelombang"
                    light
                    flat
                    dense
                    outlined
                    hide-details
                    :items="mGelombang"
                    @change="onChangeGelombang"
                  ></v-select>
                </v-col>
                <v-col cols="12" lg="6" class="py-2">
                  <v-select
                    v-model="tahunKe"
                    light
                    flat
                    dense
                    outlined
                    hide-details
                    :items="mTahun"
                    @change="onChangeTahun"
                  ></v-select>
                </v-col>
              </v-row>
            </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <base-list-filter
        ref="filter"
        title="Pilih Filter Status"
        :filtered="filtered"
        :filters="formFilter"
        :paramsFilter="filters"
        @save="filterSave"
      />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list three-line>
                <v-list-item class="px-0">
                  <v-list-item-avatar color="blue">
                    <v-icon dark>mdi-office-building-outline</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="12" lg="3">
                        <div class="subtitle-1 blue--text">
                          {{ $getDeepObj(item.psp_kp_pa_sekolah_laporan, 'sekolah.nama') || '-' }}
                        </div>
                        <div class="black--text mb-1">
                          <span class="font-weight-medium">NPSN: </span>
                          {{ $getDeepObj(item.psp_kp_pa_sekolah_laporan, 'sekolah.npsn') || '-' }}
                        </div>
                        <div class="black--text mb-1">
                          <span class="font-weight-medium">Kab/Kota: </span>
                          {{ $getDeepObj(item, 'psp_kp_pa_sekolah_laporan.sekolah.m_kota.keterangan') || '-' }}
                        </div>
                        <div class="black--text mb-1">
                          <span class="font-weight-medium">Provinsi: </span>
                          {{ $getDeepObj(item, 'psp_kp_pa_sekolah_laporan.sekolah.m_propinsi.keterangan') || '-' }}
                        </div>
                        <div class="mt-3">
                          <v-label color="caption"><small>Pelapor</small></v-label>
                          <div class="body-2 mt-1 blue--text">
                            {{
                              $getDeepObj(
                                item.psp_kp_pa_sekolah_laporan,
                                'psp_kp_pa_pendampingan.psp_profil_pa.ptk.nama'
                              ) || '-'
                            }}
                          </div>
                          <div class="black--text mt-1">
                            <span class="font-weight-medium">SIMPKB ID: </span>
                            {{
                              $getDeepObj(
                                item.psp_kp_pa_sekolah_laporan,
                                'psp_kp_pa_pendampingan.psp_profil_pa.ptk.ptk_id'
                              ) || '-'
                            }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-label color="caption"><small>Judul</small></v-label>
                        <div class="caption mt-1">
                          {{ $getDeepObj(item.m_kp_instrumen_psp, 'keterangan') || '-' }}
                        </div>
                        <div class="caption black--text">
                          <span class="font-weight-medium">Diajukan: </span>
                          {{ $localDate(item.created_at || '') }}
                        </div>
                        <v-list
                          v-if="getPmos(item) && [38, 39].includes(Number(item.k_progres_psp))"
                          class="caption py-1"
                        >
                          <v-list-item class="px-0" style="min-height: unset">
                            <v-list-item-avatar class="ma-0">
                              <v-icon color="blue" class="px-0" left>mdi-account</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content class="py-0">
                              <div class="mb-0">
                                Admin:
                                <span :class="getPmos(item) ? 'blue--text' : 'red--text'">
                                  {{ getPmos(item) ? $getDeepObj(getPmos(item), 'akun.nama') || '' : 'Belum Ada' }}
                                </span>
                              </div>
                              <div v-if="getPmos(item)">
                                Instansi:
                                <span class="blue--text" v-if="getPmos(item)">
                                  {{ getPmos(item) ? $getDeepObj(getPmos(item), 'instansi.nama') || '' : 'Belum Ada' }}
                                </span>
                              </div>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-label color="caption"><small>Status Laporan</small></v-label>
                        <div class="mt-1 font-weight-medium">
                          <v-chip dark small :color="WARNA_STATUS[item.k_progres_psp]">
                            {{ $getDeepObj(item.m_kp_opsi_psp_progres_psp, 'keterangan') || '' }}
                          </v-chip>
                        </div>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-label color="caption"><small>Aksi</small></v-label>
                        <div class="mt-1">
                          <v-btn
                            v-if="$allow('psp-peserta-pendampingan-pa.kunci', item.policies)"
                            depressed
                            small
                            dark
                            color="orange"
                            @click="onKunci(item)"
                          >
                            <v-icon left>mdi-lock</v-icon>
                            Kunci Laporan
                          </v-btn>
                          <v-btn v-else depressed small dark color="blue" @click="onEdit(item)">
                            Lihat Detail
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                  <v-list-item-action-text>
                    <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                  </v-list-item-action-text>
                </v-list-item>
              </v-list>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full ref="modal" :title="formulir.title" @save="onSave" :use-save="formulir.useSave">
      <component
        ref="formulir"
        :config="config"
        :is="formulir.form"
        :initValue="formulir.init"
        :isPreview="formulir.isPreview"
        @batalKunci="onBatalKunci"
      />
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import list from '@mixins/list';
import actions from './action';
import FormPa from '../formulir/Pa';
import { isExistArray } from '@utils/format';
export default {
  name: 'Index',
  mixins: [list],
  components: { FormPa },
  data() {
    return {
      actions: actions,
      formulir: {},
      listPa: {},
      id: null,
      panel: [],
      mProgressPa: [],
      gelombang: 2,
      tahunKe: 0,
      WARNA_STATUS: {
        31: 'success',
        32: 'orange',
        33: 'info',
        34: 'error',
        35: '#FF7F2A',
        36: 'success',
        37: '#FF4A4A',
      },
      M_GROUP: {
        dasar: 'Pertanyaan dasar',
        sdm: 'Sumber daya manusia',
        anggaran: 'Anggaran',
        teknologi: 'Teknologi',
        pembelajaran: 'Kegiatan pembelajaran',
        pemda: 'Dukungan pemerintah daerah',
        internal: 'Dukungan Internal Sekolah',
        mendesak: 'Kondisi Mendesak',
      },
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    ...mapState('preferensi', {
      diklat: (state) => (state.data && state.data.diklat) || {},
      configPendampingan: (state) => (state.data && state.data.pendampingan) || {},
    }),

    filtersMaster() {
      let M_PORGRESS = {};
      if (this.mProgressPa.length) {
        for (const item of this.mProgressPa) {
          M_PORGRESS[item.value] = item.text;
        }
      }
      return {
        k_progres_psp: M_PORGRESS,
        k_propinsi: this.masters.propinsi,
        gelombang: this.mGelombang,
        k_kota: this.masters.kota,
        grup: this.M_GROUP,
      };
    },

    configs() {
      const M_PROPINSI = (this.masters && this.masters['propinsi']) || {};
      const M_KOTA = (this.masters && this.masters['kota']) || {};
      return {
        selector: ['k_propinsi', 'k_kota'],
        required: [false, false],
        label: ['Provinsi', 'Kota/Kabupaten'],
        options: [M_PROPINSI, M_KOTA],
        grid: [
          { cols: 12, md: 6 },
          { cols: 12, md: 6 },
        ],
        disabled: [],
      };
    },

    formFilter() {
      return [
        {
          label: 'Pilih Topik',
          type: 'select',
          model: 'grup',
          master: this.$mapForMaster(this.M_GROUP),
          grid: { cols: 12, md: 6 },
        },
        {
          label: 'Pilih Status Laporan',
          default: true,
          type: 'checkbox',
          model: 'k_progres_psp',
          master: this.mProgressPa,
        },
        {
          label: 'Pilih Lokasi',
          default: true,
          type: 'cascade',
          configs: this.configs,
          labelColor: 'secondary',
          grid: { cols: 12, md: 12 },
        },
      ];
    },

    mGelombang() {
      const gelombangs = this.$getDeepObj(this.configPendampingan, 'kp-pa.gelombang') || [];
      return [...[], ...gelombangs].reverse().map((value) => {
        return {
          text: `Angkatan ${value}`,
          value,
        };
      });
    },

    mTahun() {
      const tahunKe = this.$getDeepObj(this.configPendampingan, 'kp-pa.tahun_ke') || {};
      let tahuns = [];
      for (let i = 1; i <= tahunKe[this.gelombang]; i++) {
        tahuns.push(i);
      }

      return tahuns.reverse().map((value) => {
        return {
          text: `Tahun Ke-${value}`,
          value,
        };
      });
    },
  },
  created() {
    this.getMasters('propinsi;kota');

    const gelombangs = this.$getDeepObj(this.configPendampingan, 'kp-pa.gelombang') || [];
    const tahunKe = this.$getDeepObj(this.configPendampingan, 'kp-pa.tahun_ke') || {};
    const [gelombang] = [...[], ...gelombangs].slice(-1);

    this.gelombang = gelombang;
    this.tahunKe = tahunKe[gelombang] || '';

    this.params.gelombang = this.gelombang;
    this.params.tahun_ke = this.tahunKe;
  },
  methods: {
    ...mapActions('master', ['getMasters']),
    ...mapActions('diklatPmo', ['fetch', 'getDetail', 'update', 'action']),

    isExistArray(source, target) {
      return isExistArray(source, target);
    },

    fetchData: function() {
      return new Promise((resolve) => {
        const params = Object.assign({}, this.params, this.$isObject(this.filters) ? this.filters : {});
        const attr = Object.assign({}, this.attr);
        this.fetch({ params, attr }).then(({ data, meta, total, last_page, per_page }) => {
          this.data = data || [];
          this.total = total || meta?.total || 0;
          this.pageTotal = last_page || meta?.last_page || 1;
          this.params.limit = per_page || meta?.per_page || this.params.limit;
          this.statistik = meta?.statistik || {};
          this.config = meta?.config || {};
          this.mProgressPa = ((meta && meta['progress-pa']) || []).map((item) => {
            return {
              text: item.keterangan,
              value: item.k_kp_opsi_psp,
            };
          });
          resolve(true);
        });
      });
    },

    async onEdit(item) {
      const { data, meta } = await this.getDetail({ id: item.psp_kp_pa_sekolah_instrumen_id });
      const masterStatus = this.$arrToObj(meta && meta['progress-pa'], 'k_kp_opsi_psp');
      this.config = Object.assign({}, meta?.config || {}, { progress_pa: masterStatus || {} });

      const preview =
        !this.$allow('psp-peserta-pendampingan-pa.update', item.policies) ||
        !this.isExistArray(data.status_instansi, data.status_update);
      this.$set(this.formulir, 'form', 'FormPa');
      this.$set(this.formulir, 'title', 'Kelola PA Anggota Koordinator');
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'isPreview', preview || false);
      this.$set(this.formulir, 'useSave', !preview);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', data);
      });
    },

    onSave() {
      const { form, id } = this.$refs.formulir.getValue();
      // validate
      if (!form.k_progres_psp || !form.catatan) {
        this.$error('Silakan memberikan tanggapan terkait Laporan');
        this.$refs.modal.loading = false;
        return;
      }

      this.update({ id, params: form })
        .then(() => {
          this.$success(`Tanggapan Anda terkait Laporan berhasil disimpan`);
          this.$refs.modal.close();
          this.onReload();
        })
        .catch((error) => {
          this.$error(error);
          this.$refs.modal.loading = false;
        });
    },

    onBatal(item) {
      this.$confirm(
        `<span class="black--text">Anda yakin ingin membatalkan tanggapan Laporan
                <strong>${this.$getDeepObj(item.m_kp_instrumen_psp, 'keterangan') || '-'}</strong> ?</span>`,
        `Batal Tanggapan Laporan`,
        {
          tipe: 'error',
          data: '',
        }
      ).then(() => {
        this.action({ id: item.psp_kp_pa_sekolah_instrumen_id, type: 'batal' }).then(() => {
          this.$success('Tanggapan Laporan berhasil dibatalkan');
          this.onReload();
        });
      });
    },

    getPmos(data) {
      const instruments = this.$getDeepObj(data, 'psp_kp_pa_sekolah_instrumen_pmos') || [];
      return instruments.find((s) => Number(s.k_progres_psp) === Number(data.k_progres_psp)) || false;
    },

    onKunci(data) {
      this.id = data.psp_kp_pa_sekolah_instrumen_id;
      this.$confirm(`Anda yakin ingin mengunci Ajuan di atas agar bisa diverifikasi?`, `Kunci Ajuan`, {
        tipe: 'warning',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({ id: this.id, type: 'kunci' }).then(() => {
          this.$success(`Ajuan Peserta berhasil dikunci`);
          this.onReload();
        });
      });
    },

    onBatalKunci(data) {
      this.$confirm(`Anda yakin ingin membatalkan Kunci Verifikasi Ajuan Laporan di atas?`, `Batal Kunci Ajuan`, {
        tipe: 'error',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({ id: data.psp_kp_pa_sekolah_instrumen_id, type: 'batal-kunci' }).then(() => {
          this.$success(`Batal kunci Ajuan Peserta berhasil`);
          this.onReload();
          if (this.$refs.modal) this.$refs.modal.close();
        });
      });
    },

    confirmHtml(data) {
      return [
        {
          icon: 'mdi-account-circle',
          iconSize: 60,
          iconColor: 'secondary',
          title: this.$getDeepObj(data, 'psp_kp_pa_sekolah_laporan.sekolah.nama') || '',
          subtitles: [
            `<span class="text--primary">${this.$getDeepObj(
              data,
              'psp_kp_pa_sekolah_laporan.psp_kp_pa_pendampingan.psp_profil_pa.ptk.nama'
            )}</span>`,
            `<span>${this.$getDeepObj(data, 'm_kp_instrumen_psp.keterangan')}</span>`,
          ],
        },
      ];
    },

    onChangeGelombang(value) {
      const tahunKe = this.$getDeepObj(this.configPendampingan, 'kp-pa.tahun_ke') || {};
      this.params.gelombang = value;
      this.params.tahun_ke = tahunKe[value];
      this.tahunKe = tahunKe[value];
      this.onReload();
    },

    onChangeTahun(value) {
      this.params.tahun_ke = value;
      this.onReload();
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
